module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./EnterDetailView.js"));
	}, "EnterDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EnterDetailView!./src/pages/Promote/OfflineActivity/EnterActivity/EnterDetail/EnterDetailView.js
// module id = 2103
// module chunks = 367